import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UserDetailsService } from "src/app/Components/Services/user-details.service";
import { EUserGuide } from "src/app/Models/Enum/user-guide";
import { APIName } from "../../../Models/APIEndPoints/APIName";
import { DataService } from "src/app/Services/DataService/data.service";
@Component({
  selector: "app-video-work",
  templateUrl: "./video-work.component.html",
  styleUrls: ["./video-work.component.scss"],
})
export class VideoWorkComponent implements OnInit {
  guide = EUserGuide;

  constructor(
    private dataService: DataService,
    public dialogRef: MatDialogRef<VideoWorkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public userDetailsService: UserDetailsService
  ) {}

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(guide: EUserGuide): void {
    this.dataService.get(APIName.user.HelpRequest).subscribe((res: any) => {});

    this.dialogRef.close(guide);
  }
}
